/***
 *
 *   LANDING CTA
 *   Deep-indigo closing band: sign-up push beside a lead form.
 *
 **********/

import { Link, ContactForm } from 'components/lib';
import { useTranslate } from 'app/translations';
import { rootPath } from 'utilities/routes.js';
import Shared from './landing.tailwind.js';
import Style from './cta.tailwind.js';

const CONTACT_EMAIL = 'hello@valetify.io';

export function LandingCta(props) {
    const { _t } = useTranslate();

    return (
        <section id="contact" className={Style.section}>
            <div className={Style.glow} aria-hidden="true" />

            <div className={`${Shared.container} ${Shared.split} items-start`}>
                <div>
                    <div className={Style.eyebrow}>{_t('landing.cta.eyebrow')}</div>
                    <h2 className={Style.title}>{_t('landing.cta.title')}</h2>
                    <p className={Style.lede}>{_t('landing.cta.lede')}</p>

                    <div className={Style.actions}>
                        <Link
                            url={rootPath('/signup')}
                            color="white"
                            text={_t('landing.cta.primary')}
                            className={Style.primary}
                        />
                        <a href={`mailto:${CONTACT_EMAIL}`} className={Style.email}>
                            {CONTACT_EMAIL}
                        </a>
                    </div>
                </div>

                <div className={Style.card}>
                    <ContactForm
                        teamSize
                        buttonText={_t('landing.cta.form.submit')}
                        labels={{
                            name: _t('landing.cta.form.name'),
                            email: _t('landing.cta.form.email'),
                            teamSize: _t('landing.cta.form.teamSize'),
                            message: _t('landing.cta.form.message'),
                        }}
                        placeholders={{
                            name: _t('landing.cta.form.namePlaceholder'),
                            email: _t('landing.cta.form.emailPlaceholder'),
                            message: _t('landing.cta.form.messagePlaceholder'),
                        }}
                    />
                </div>
            </div>
        </section>
    );
}
